/**
 * ワイド型モーダルの枠の大きさ（埋め込みの WideModal と管理画面プレビューで共有する）。
 * 16:9 の動画を幅と高さの両方に収まる最大サイズにする（目次は動画に重ねるので枠の幅は取らない）。
 */

/**
 * 枠の最大幅。ふだんは画面の高さで決まり（16:9 で画面に収まる最大）、とても大きな画面でだけこの幅で止める。
 * 以前は 1180px で止めていたため、大きな PC 画面でも上下左右に大きな余白が残っていた
 */
export const WIDE_FRAME_MAX_WIDTH = 1440
/** 画面の左右の余白の合計。右上の閉じるボタン（右18px・幅38px）が動画に重ならない幅にする */
const WIDE_FRAME_HORIZONTAL_MARGIN = 128

/**
 * 16:9 の動画部分の幅（CSS の式）。
 * @param verticalMargin 画面の高さから引く余白（上下の余白・プレビューの保存バーなど）
 */
export const wideVideoWidthCss = (verticalMargin: number): string =>
  `min(${WIDE_FRAME_MAX_WIDTH}px, calc(100vw - ${WIDE_FRAME_HORIZONTAL_MARGIN}px), calc((100vh - ${verticalMargin}px) * 16 / 9))`

/** 目次を動画の左に重ねて出す画面幅。これより狭いと動画の多くを覆うので、目次はボタンから開く */
export const WIDE_AGENDA_SIDE_MEDIA_QUERY = '(min-width: 1024px)'
